/**
 * API가 응답하는 빌링 페이지 URL에 sayurl 쿼리스트링에
 * 결제 후 돌아오는 포커 게임홈 bridge 페이지 주소가 들어감
 * VIP 쿠폰을 사용할 경우 브릿지 페이지에서 API 요청할 때 vip 쿠폰을 사용할 수 있도록
 * sayurl에 쿼리스트링을 추가하는 함수
 */
export function appendQueryToSayurl(url, appendQuery) {
  const urlObj = new URL(url)

  const sayurl = urlObj.searchParams.get('sayurl')
  if (!sayurl) return url // sayurl 없으면 원본 반환

  urlObj.searchParams.set('sayurl', sayurl + appendQuery)

  return urlObj.toString()
}
